// This reducer takes care of UI properties, that should persist to the server

import { actionsTypes as types } from "../actions/uiActions";
import { actionsTypes as userTypes } from "../actions/userActions";

const INITIAL_STATE = {
  uiMode: true, // true: edit mode, false: presentation mode,
  presentationMode: 0, //
  templateBlacklist: [] // This keeps track of denied "Do you want to auto configure this device?" Dialogs.
};

const uiConfigReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userTypes.RECEIVE_PERSISTET_UI_CONFIG:
      // INJECT widgetSettings: INITIAL_WIDGET_SETTINGS here?

      return { ...state, ...action.uiConfig };

    case types.TOGGLE_UIMODE:
      //console.log("TOGGLE UI MODE reducer")
      return {
        ...state,
        uiMode: !state.uiMode
      };

    case types.SET_UIMODE:
      return {
        ...state,
        uiMode: action.mode
      };

    case types.SET_PRESENTATION_VIEW_MODE:
      //console.log("SET_PRESENTATION_VIEW_MODE REDUCER", action);
      return {
        ...state,
        presentationMode: action.mode
      };

    case types.ADD_TO_DEVICE_TEMPLATE_BLACKLIST:{
      console.log("ADD_TO_DEVICE_TEMPLATE_BLACKLIST reducer called!");
      let { device_uid, template_val } = action;
      let newEntry = { device_uid, template_val };
      return {
        ...state,
        templateBlacklist: [...state.templateBlacklist, newEntry]
      }
    }

    case types.REMOVE_FROM_DEVICE_TEMPLATE_BLACKLIST: {
      console.log("REMOVE_FROM_DEVICE_TEMPLATE reducer called!");
      let { device_uid } = action;
      let newBlacklist = state.templateBlacklist.filter(listItem => {
        let {device_uid:list_device_uid=0} = listItem;
        return !(list_device_uid === device_uid);
      });
      return {...state, templateBlacklist: newBlacklist};
    }
    
    default:
      return state;
  }
};

export default uiConfigReducer;
